import {useEffect, useState} from 'react';
import {NavLink, Outlet, useNavigate} from 'react-router';

import KyError from 'components/Errors/KyError';
import useAppContext from 'conf/AppContext';

import './index.scss';

export default function DashboardPage() {

  const appContext = useAppContext();
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const loadData = async () => {
      try {
        const rez = await appContext.api.get('api/v1/users/profile', {
          parseJson: true,
        });
        setData(rez);
      } catch (err) {
        if (err?.response?.status === 401) {
          localStorage.clear();
          navigate('/');
        }
        setError(err);
      }
    };
    loadData();
  }, []);


  let content = (
    <div className="col-lg-3 col-md-5 col-sm-12">
      <div className="card text-center mb-3">
        <div className="card-body">
          <p className="card-text placeholder-glow">
            <span className="placeholder col-12" />
            <span className="placeholder col-12" />
            <span className="placeholder col-12" />
            <span className="placeholder col-12" />
            <span className="placeholder col-12" />
          </p>
        </div>
      </div>
      <div className="card mb-3">
        <div className="card-body">
          <p className="card-text placeholder-glow">
            <span className="placeholder col-12" />
            <span className="placeholder col-12" />
            <span className="placeholder col-12" />
            <span className="placeholder col-12" />
            <span className="placeholder col-12" />
          </p>
        </div>
      </div>
    </div>
  );
  if (data) {
    content = (
      <div className="col-lg-3 col-md-5 col-sm-12 user">
        <div className="card mb-3">
          <div className="card-body">
            <ul className="nav nav-pills nav-justified-start flex-column">
              <li className="nav-item mb-2">
                <NavLink to="/dashboard/score" end={true} className="nav-link fs-6 text fw-semibold">
                  <i className="bi bi-speedometer me-2" />
                  Score
                </NavLink>
              </li>
              <li className="nav-item mb-2">
                <NavLink to="/dashboard/github" end={true} className="nav-link fs-6 text fw-semibold">
                  <i className="bi bi-github me-2" />
                  GitHub
                </NavLink>
              </li>
              <li className="nav-item mb-2">
                <NavLink to="/dashboard/techStack" end={true} className="nav-link fs-6 text fw-semibold">
                  <i className="bi bi-stack me-2" />
                  Tech Stack
                </NavLink>
              </li>
              {renderRestrictedDashboard(data)}
              <li className="nav-item mb-2">
                <NavLink to="profile" end={true} className="nav-link fs-6 text fw-semibold">
                  <i className="bi bi-person-circle me-2" />
                  Profile
                </NavLink>
              </li>
              <li className="nav-item mb-2">
                <NavLink to="password" end={true} className="nav-link fs-6 text fw-semibold">
                  <i className="bi bi-key me-2" />
                  Password
                </NavLink>
              </li>
              <li className="nav-item mb-2">
                <NavLink to="settings" end={true} className="nav-link fs-6 text fw-semibold">
                  <i className="bi bi-gear-wide-connected me-2" />
                  Settings
                </NavLink>
              </li>
              <li className="nav-item mb-2">
                <NavLink to="authorization" end={true} className="nav-link fs-6 text fw-semibold">
                  <i className="bi bi-shield-exclamation me-2" />
                  Authorization
                </NavLink>
              </li>
              <li className="nav-item mb-2">
                <NavLink to="authentication" end={true} className="nav-link fs-6 text fw-semibold">
                  <i className="bi bi-lock-fill me-2" />
                  Authentication (MFA)
                </NavLink>
              </li>
            </ul>
          </div>
        </div>
      </div>
    );
  } else if (error) {
    content = <KyError kyError={error} />;
  }

  return (
    <div className="container main">
      <div className="row">
        {content}
        <div className="col-lg-9 col-md-7 col-sm-12">
          <div className="card">
            <div className="card-body">
              <Outlet />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}


function renderRestrictedDashboard(data) {
  if (data.data.user.role === 'ADMIN' || data.data.user.role === 'SUPER_ADMIN') {
    return (
      <>
        <li className="nav-item mb-2">
          <NavLink to="edit/companies" end={true} className="nav-link fs-6 text fw-semibold">
            <i className="bi bi-building me-2" />
            Companies
          </NavLink>
        </li>
        <li className="nav-item mb-2">
          <NavLink to="edit/techStacks" end={true} className="nav-link fs-6 text fw-semibold">
            <i className="bi bi-code me-2" />
            Tech Stacks
          </NavLink>
        </li>
        <li className="nav-item mb-2">
          <NavLink to="edit/users" end={true} className="nav-link fs-6 text fw-semibold">
            <i className="bi bi-person me-2" />
            Users
          </NavLink>
        </li>
      </>
    );
  }
}
